import { render, staticRenderFns } from "./nextDiscussAnn.vue?vue&type=template&id=127a8024&scoped=true&"
import script from "./nextDiscussAnn.vue?vue&type=script&lang=js&"
export * from "./nextDiscussAnn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a8024",
  null
  
)

export default component.exports